import React from 'react';
import PageProgress from 'react-page-progress'
import SideBar from "./components/Sidebar";
import Intro from "./components/Intro";
import Basics from "./components/Basics";
import Diet from "./components/Diet";
import Workout from "./components/Workout";
import Mistakes from "./components/Mistakes";
import Myths from "./components/Myths";
import {CircleArrow as ScrollUpButton} from "react-scroll-up-button";

export default function App() {
  return (
    <div>
	    <PageProgress color={'#dc3545'} height={7} />
		<SideBar />
		
		<section className="page-header">
			<h1 className="project-name">FitnessGyaan</h1>
			<h3 className="project-tagline">No Bullshit, No Myths, <strong>Only Facts!</strong></h3>
			<hr id="top"/>
		</section>
  
		<section className="main-content">
			<Intro/>
			
			<hr id="basics"/>
			<Basics/>
				
			<hr id="diet"/>	
			<Diet/>
			
			<hr id="workout"/>
			<Workout/>			
			
			<hr id="mistakes"/>	
			<Mistakes/>
			
			<hr id="myths"/>
			<Myths/>	
		</section>
		
		<ScrollUpButton ShowAtPosition={200} style={{width:30,height:45}} ToggledStyle={{right:1}}/>
	</div>
  );
}
